import ApiService from "@/common/api/api.service";

let apiBasePath = 'Curso'
const CursoService = {
  async criar(form) {
    let { data } = await ApiService.post(`${apiBasePath}`, form);
    return data;
  },
  async editar(form) {
    let { data } = await ApiService.put(`${apiBasePath}`, form);
    return data;
  },
  async excluir(aulaId) {
    let { data } = await ApiService.delete(`${apiBasePath}/${aulaId}`);
    return data;
  },
  async listar() {
    let { data } = await ApiService.get(`${apiBasePath}`);
    return data;
  },
  async obterPorId(cursoId) {
    let { data } = await ApiService.get(`${apiBasePath}/${cursoId}`);
    return data;
  },
  async obterPorAnoLetivo(anoLetivoId) {
    let { data } = await ApiService.get(`${apiBasePath}/obter-por-anoLetivo?id=${anoLetivoId}`);
    return data;
  },
  async obterPorAnoLetivoTipoContrato(anoLetivoId, tipoContratoId) {
    let { data } = await ApiService.get(`${apiBasePath}/obter-por-anoLetivo-tipoContrato?anoLetivoId=${anoLetivoId}&tipoContratosEnum=${tipoContratoId}`);
    return data;
  },
  async obterCursosPaginado(paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${apiBasePath}/obter-cursos-paginado`,
      {
        params: { 
          NumeroDaPagina: paginacao.numeroDaPagina,
          TamanhoDaPagina: paginacao.tamanhoDaPagina, 
          CampoOrdenado : campoOrdenado, 
          OrdenacaoAscendente:ordem
        },
      });
    return data;
  },
};

export default CursoService;